import React from 'react';
import { formatGestureForDisplay } from '../../utils/ProsodyGestureSets';

const SetProsodyRecordingSettings = ({
    gesture,
    handleGestureChange,
    selectedSet,
    handleSetChange,
    isRecording,
    gestureError,
    sets,
    gestureCounts = {}
}) => {
    return (
        <div className="recording-settings">
            <div className="gesture-selection-container">
                <select
                    value={selectedSet}
                    onChange={handleSetChange}
                    disabled={isRecording}
                    className={`gesture-category-dropdown ${gestureError ? 'error' : ''}`}
                    style={gestureError ? { border: '2px solid red' } : {}}
                >
                    <option value="" disabled>
                        Select a set
                    </option>
                    {sets.map((set) => (
                        <option key={set.id} value={set.id}>
                            {set.label}
                        </option>
                    ))}
                </select>

                {selectedSet && (
                    <div className="gesture-dropdown-row">
                        <select
                            value={gesture}
                            onChange={handleGestureChange}
                            disabled={isRecording}
                            className={`gesture-dropdown ${gestureError ? 'error' : ''}`}
                            style={gestureError ? { border: '2px solid red' } : {}}
                        >
                            <option value="" disabled>
                                Select a gesture
                            </option>
                            {sets
                                .find((s) => s.id === selectedSet)
                                ?.gestures.filter((g) => (gestureCounts[g] || 0) === 0 || g === gesture)
                                .map((g) => (
                                    <option key={g} value={g}>
                                        {formatGestureForDisplay(g)}
                                    </option>
                                ))}
                        </select>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SetProsodyRecordingSettings;
